
<script>
import env from "./env";
const realUrl_CONF = {
  // dev: 'http://192.168.2.198:8087/kcms/public', // dev
  // development: 'http://192.168.2.198:8087/kcms/public', // development
  // dev: 'http://kaifancmsadmtest.cipgtrans.com/kcms/public', // dev
  development: "http://kaifancmsadm.cipgtrans.com/kcms/public", //"http://kaifancmsadmtest.cipgtrans.com/kcms/public", // development
  dev: "http://kaifancmsadm.cipgtrans.com/kcms/public", // dev
  // development: 'http://kaifancmsadm.cipgtrans.com/kcms/public', // development
  test: "", // 测试环境
  // production: 'http://kaifancmsadmtest.cipgtrans.com/kcms/public', // build 测试环境
  production: "http://kaifancmsadm.cipgtrans.com/kcms/public", // build 线上环境
};
const realUrl = realUrl_CONF[env];
export default {
  realUrl,
};
</script>

